import { LiveStream } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/metadata/live-stream';

import { NAMES, NAMES as LIVESTREAM_ACTIONS } from '../../actions/live-streams';

export enum LiveStreamListFilter {
  None,
  Active,
  Inactive,
}

interface ILiveStreamsState {
  streams: LiveStream[];
  nextPageToken?: string;
  isLoadingMore: boolean;
  stateFilter: LiveStreamListFilter;
  selectedLiveStreamId: String | null;
}

const defaultState = {
  streams: [],
  nextPageToken: undefined,
  isLoadingMore: false,
  stateFilter: LiveStreamListFilter.None,
  selectedLiveStreamId: null,
};

export const liveStreams = (
  state: ILiveStreamsState = defaultState,
  action,
) => {
  switch (action.type) {
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_SET_STATE_FILTER:
      return {
        ...state,
        nextPageToken: undefined,
        stateFilter: action.payload,
      };
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_SUCCESS:
      return {
        ...state,
        ...action.payload.rawResponse,
      };

    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_MORE_START:
      return {
        ...state,
        isLoadingMore: true,
      };

    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_MORE_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        streams: state.streams.concat(action.payload.rawResponse.streams),
        nextPageToken: action.payload.rawResponse.nextPageToken,
      };
    case LIVESTREAM_ACTIONS.LIVE_STREAMS_GET_MORE_ERROR:
      return {
        ...state,
        isLoadingMore: false,
      };

    case NAMES.LIVE_STREAMS_GET_ERROR:
      return {
        ...state,
        errorCode: action.payload.errorCode,
      };

    case LIVESTREAM_ACTIONS.SELECT_STREAM:
      return {
        ...state,
        selectedLiveStreamId: action.payload,
      };

    default:
      return state;
  }
};
